module.exports = __webpack_public_path__ + "img/18_84.ee144b38.png";